import { type OnboardingName } from './interfaces';

export const COPILOT_ONBOARDING_DELAY = 7000;
export const COPILOT_ONBOARDING_PRIORITY: OnboardingName[] = ['copilot-onboarding'];
